import { Injectable } from '@angular/core';
import { TableColumn } from './table.types';

@Injectable({ providedIn: 'root' })
export class TableConfig {
  defaultPageSize = 10;
  pageSizeOptions = [5, 10, 20, 50, 100];
  showFilterRow = true;
  showExport = true;
  stickyHeader = true;

  defaultColumns<T>(cols: TableColumn<T>[]): TableColumn<T>[] {
    return cols.map((c) => ({
      sortable: true,
      filterable: true,
      visible: true,
      align: 'left',
      ...c,
    }));
  }
}
